import { api } from "../../api";


// 0) Acquire as a key value pair the business and the token of all in the database
export async function scanAndInsert(device) {
    const response = await api.get(`/scan/${device}`);
    
    // Print the full response
    
    // Get the Google review URL if it exists
    if (response.data.length > 0) {
        const googleReviewUrl = response.data[0].google_review_url;
        console.log('Google review URL:', googleReviewUrl);
        return googleReviewUrl;
    } else {
        console.log('No device found or no review URL');
        return null;
    }
}